// -----------------------------------------------------------------------------
// Slider on the front page
// -----------------------------------------------------------------------------

// Main slider on the top front page
var offersSlider = function (el) {
  el.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 6000,
    accessibility: false,
    arrows: true,
    infinite: true,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      }
    }, {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
      }
    }]
  });
};